import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AssignmentsUsageAnalytics from "./routes/AssignmentsUsageAnalytics";
import CurriculumPlanningUsageAnalytics from "./routes/CurriculumPlanningUsageAnalytics";
import MessagingUsageAnalytics from "./routes/MessagingUsageAnalytics";
import OverviewUsageAnalytics from "./routes/OverviewUsageAnalytics";
import PortfolioUsageAnalytics from "./routes/PortfolioUsageAnalytics";

export default store => {
  return {
    path: "module-usage",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "module-usage" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      // AnnouncementsUsageAnalytics(store),
      AssignmentsUsageAnalytics(store),
      CurriculumPlanningUsageAnalytics(store),
      MessagingUsageAnalytics(store),
      OverviewUsageAnalytics(store),
      PortfolioUsageAnalytics(store),
    ],
  };
};
